import { atom } from "recoil";
import { Day, Uid } from "../types/core";

/** Who the New route card was opened for; the card itself is open while draw mode has composer "route". */
export const routeComposerContextState = atom<{ uid?: Uid }>({
    key: "app.routeComposer.context",
    default: {},
});

export type DraftStopMarker = {
    key: string;
    number: number;
    lat: number;
    lng: number;
    eta?: string;
    late?: boolean;
    /** said above the stop in place of the time, e.g. "was 3" */
    note?: string;
};

/** A previewed better order against the day route: the legs it keeps, adds and drops, and when the preview opened. */
export type DraftLegs = {
    kept: [number, number][][];
    added: [number, number][][];
    gone: [number, number][][];
    /** performance.now() when the preview opened, for the change to play once */
    at: number;
};

/**
 * The draft of the New route card on the map: its road line in place of the person's day route, and its new stops.
 * A previewed better order uses it too, with its changed legs and the jobs' numbers in the new order.
 */
export const draftRouteState = atom<{
    uid?: Uid;
    day: Day;
    path: [number, number][];
    stops: DraftStopMarker[];
    legs?: DraftLegs;
    numbers?: Record<string, number>;
    /** only the draft's own stops on the map, none of the person's jobs that day (a recurring route's planned day) */
    stopsOnly?: boolean;
} | undefined>({
    key: "map.draftRoute",
    default: undefined,
});
